import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../utils/Auth/AuthProvider";
import { WELCOME_PATH, mustChangePassword } from "../utils/Auth/firstLogin";

export const ProtectedRoute = () => {
    const { token } = useAuth();
    const { pathname } = useLocation();
  
    // Check if the user is authenticated
    if (!token) {
      // If not authenticated, redirection is handled by AuthProvider
      return null; // Or a loading spinner, or a component that doesn't navigate
    }
  
    // A temporary password must be replaced before anything else opens.
    if (mustChangePassword() && pathname !== WELCOME_PATH && pathname !== '/logout') {
      return <Navigate to={WELCOME_PATH} replace />;
    }

    // If authenticated, render the child routes
    return <Outlet />;
  };